document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-faq-split]").forEach((wrap) => {
    const single = wrap.getAttribute("data-faq-single") === "true";
    const items = wrap.querySelectorAll("[data-faq-item]");

    const closeItem = (item) => {
      const ans = item.querySelector("[data-faq-answer]");
      if (!ans) return;

      // animate close
      ans.style.height = ans.scrollHeight + "px";
      requestAnimationFrame(() => {
        ans.style.height = "0px";
      });

      item.classList.remove("is-open");
      const btn = item.querySelector("[data-faq-btn]");
      if (btn) btn.setAttribute("aria-expanded", "false");
    };

    const openItem = (item) => {
      const ans = item.querySelector("[data-faq-answer]");
      if (!ans) return;

      // close others if single mode
      if (single) {
        items.forEach((x) => {
          if (x !== item && x.classList.contains("is-open")) closeItem(x);
        });
      }

      item.classList.add("is-open");
      const btn = item.querySelector("[data-faq-btn]");
      if (btn) btn.setAttribute("aria-expanded", "true");

      // animate open
      ans.style.height = "0px";
      requestAnimationFrame(() => {
        ans.style.height = ans.scrollHeight + "px";
      });

      // cleanup after transition (so content isn't clipped)
      const onEnd = (e) => {
        if (e.propertyName !== "height") return;
        if (item.classList.contains("is-open")) {
          ans.style.height = "auto";
        }
        ans.removeEventListener("transitionend", onEnd);
      };
      ans.addEventListener("transitionend", onEnd);
    };

    items.forEach((item) => {
      const btn = item.querySelector("[data-faq-btn]");
      const ans = item.querySelector("[data-faq-answer]");
      if (!btn || !ans) return;

      // start closed
      ans.style.height = "0px";
      btn.setAttribute("aria-expanded", "false");

      btn.addEventListener("click", () => {
        const isOpen = item.classList.contains("is-open");
        if (isOpen) {
          closeItem(item);
        } else {
          openItem(item);
        }
      });
    });

    // Open first item if enabled
    const openFirst = wrap.getAttribute("data-faq-open-first") === "true";
    if (openFirst && items.length) {
      openItem(items[0]);
    }
  });
});
